import { defineStore } from "pinia";
import { evidenceService } from "@/_services";

export const evidenceStore = defineStore("evidence", {
  state: () => ({
    evidences: null,
    evidence: null,
    error: null,
    customFilterDate: null,
  }),

  actions: {
    clear() {
      this.evidences = null;
      this.evidence = null;
      this.error = null;
      this.customFilterDate = null;
    },
    setCustomFilterDate(value){
      this.customFilterDate= value;
    },
    getEvidenceById(evidenceId) {
      this.evidence = null;
      this.error = null;
      return evidenceService
        .getEvidenceById(evidenceId)
        .then((result) => {
          this.evidence = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    getEvidences(pagination, query, sort) {
      this.error = null;
      return evidenceService
        .getEvidences(pagination, query, sort)
        .then((result) => {
          this.evidences = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
  },
});
